var _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIgrasoftSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "112.744,322.783 120.757,389.565 391.243,389.565 399.256,322.783  "
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M395.13,133.565H283.826V83.478c0-9.22,7.475-16.696,16.696-16.696H384c9.22,0,16.696-7.475,16.696-16.696V16.696 C400.696,7.475,393.22,0,384,0h-83.478c-46.104,0-83.478,37.374-83.478,83.478v50.087H116.87 c-27.619,0-50.087,22.468-50.087,50.087v16.696h378.435v-16.696C445.217,156.033,422.75,133.565,395.13,133.565z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "102.058,233.739 108.737,289.391 403.263,289.391 409.942,233.739  "
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M124.763,422.957l8.921,74.337c1.012,8.391,8.12,14.707,16.577,14.707h211.478c8.457,0,15.565-6.315,16.577-14.707 l8.921-74.337H124.763z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIgrasoftSvg);
export default __webpack_public_path__ + "static/media/igrasoft-svg.a732e1f59d7652b101fc6ea5c793132d.svg";
export { ForwardRef as ReactComponent };